import { t } from '@transifex/native';
import type { ReactNode } from 'react';

import useInterval from 'pkg/hooks/useInterval';

import { InfoScreen } from 'components/info_screen';

interface MaintenanceModeProps {
	refresh: () => void;
}

export default function MaintenanceMode({
	refresh,
}: MaintenanceModeProps): ReactNode {
	useInterval(() => {
		refresh();
	}, 5000);

	return (
		<InfoScreen
			icon="info"
			heading={t(`Maintenance`)}
			message={t(`360Player is down for maintenance. Please check back later.`)}
		/>
	);
}
